import PropTypes from 'prop-types';

// Leaf module: `CheckBannerStepDialogContent` reads this shape while the dialog index is
// evaluated, and the index and `steps` import each other - so it cannot live on `steps`.
export const stepPropTypesShape = PropTypes.shape({
  title: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  initialValues: PropTypes.object,
  dialogContentComponent: PropTypes.node.isRequired,
  validationSchema: PropTypes.object.isRequired,
  isChecked: PropTypes.func.isRequired,
  displayAfterStep: PropTypes.func,
  hideCheckBanner: PropTypes.bool,
  isDisplayed: PropTypes.func,
});
